import React from "react";

import ReactSliderWrapper from "./ReactSliderWrapper";

export default function AverageBasket() {
    return <ReactSliderWrapper />;
}
